import { render } from "./ECPanel.vue?vue&type=template&id=2c87b6cc&scoped=true"
import script from "./ECPanel.vue?vue&type=script&lang=js"
export * from "./ECPanel.vue?vue&type=script&lang=js"

import "./ECPanel.vue?vue&type=style&index=0&id=2c87b6cc&lang=scss&scoped=true"

import exportComponent from "D:\\projects\\gitlab\\DemoLab\\DemoLab-data\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c87b6cc"]])

export default __exports__